export const bloodTypes = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
export const fileTypes = [
  { label: "Medical Record", value: "medical_record" },
  { label: "Imaging", value: "imaging" },
  { label: "Lab Results", value: "lab_results" },
  { label: "Notes", value: "notes" },
  { label: "Other", value: "other" },
];
